class BuyBar extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.scrollEvent.bind(this));
  }

  scrollEvent() {
    const mainProduct = document.querySelector('.main-product');

    if (!mainProduct) { return; }

    if (window.scrollY >= (mainProduct.offsetHeight + 100)) {
      this.classList.remove('hide');
    } else {
      this.classList.add('hide');
    }
  }
}

customElements.define('buy-bar', BuyBar);
